enum LeagueEntryTimeFilterEnum {
  Today = 0,
  Future = 1,
}

export default LeagueEntryTimeFilterEnum;
